import {useGetCarouselsGames} from "@/hooks/gamesList/useGetCarouselsGames";
import CustomCarouselRow from "./CustomCarouselRow";
import styles from "./custom-carousels.styles.module.scss";

const CustomCarousels = () => {
  const {carousels, isPending, isError} = useGetCarouselsGames();
  const carouselPlacementItems = carousels.filter(
    carousel => String(carousel.placement || "").toLowerCase() === "carousel"
  );

  if (isPending || isError || !carouselPlacementItems.length) {
    return null;
  }

  return (
    <div className={styles.sectionList}>
      {carouselPlacementItems.map(carousel => (
        <CustomCarouselRow
          key={carousel.id}
          carousel={carousel}
        />
      ))}
    </div>
  );
};

export default CustomCarousels;
